import { QueryServices } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

export const UserServices = {
  userQueryService: async (bodyData) => {
    try {
      const payload = {
        ...QueryServices.userQuery,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  userContactUsService: async (bodyData) => {
    try {
      const payload = {
        ...QueryServices.userContactUs,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
